<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Mark Authority-Level</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><b>Approving Category*</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="inv_finance_approving_category"
                :items="inv_finance_approving_category_list"
                item-text="name"
                item-value="id"
                label="Approving Category"
                outlined
                />
        </v-col>
        <v-col cols="12" sm="3">
            <p><b>Approving Authority*</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="inv_finance_approving_authority"
                :items="inv_finance_approving_authority_list"
                item-text="name"
                item-value="id"
                label="Approving Authority"
                outlined
                />
        </v-col>
         <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Level No</b></p>
            <v-text-field
              outlined
              dense
              rounded
              type="number"
              v-model="level_no"
            ></v-text-field>
          </v-col>
            <v-col cols="12" sm="2" md="2">
              <p><v-icon color="error">*</v-icon><b>Is Last?</b></p>
              <v-checkbox
                dense
                v-model="islast"
                color="success"
                label="Is Last Level?"
              ></v-checkbox>
            </v-col>
        </v-row>
        <v-row justify="center" dense v-if="inv_finance_approving_category && inv_finance_approving_authority && level_no">
          <v-btn color="warning" @click="saveInventoryFinanceApprovingAuthorityLevel()" :loading="loader"
            >Add</v-btn
          >
        </v-row>
       </v-card>

     <v-card class="box" v-if="inv_finance_approving_auth_level_list!='' ">
     <v-data-table  :headers="headers" :items="inv_finance_approving_auth_level_list" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Finance Approving Authority-Level List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.isactive`]="{ item }">
                 <v-switch v-model="item.isactive"  @change="toggleIsactiveInventoryFinanceApprovingAuthorityLevel(item)"
                 :color="item.isactive ? 'success' : 'primary'"></v-switch>
      </template>
       <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteInventoryFinanceApprovingAuthorityLevel(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="editDetail(item)"
                >mdi-pencil</v-icon
              >
            </v-avatar>
          </template>
           <template v-slot:[`item.islast`]="{ item }">
            <span v-if="item.islast">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
     </v-data-table>
 </v-card>

         <v-dialog
        v-model="dialog_edit"
        persistent
        scrollable="false"
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Depreciation Cycle</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <br>
            <v-row justify="center" dense>
                <v-col cols="12" sm="3">
            <p><b>Financial Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="editedItem.ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Instructor"
              outlined
              disabled
            />
                </v-col>
            </v-row>
             <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Name Of Cycle</b></p>
            <v-text-field  outlined dense type="text" v-model="editedItem.name" ></v-text-field>
        </v-col>
         <v-col cols="12" sm="3">
            <p><b>From Date</b></p>
            <v-text-field
              outlined
              dense
              type="date"
              v-model="editedItem.fromdate"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="3">
            <p><b>To Date</b></p>
            <v-text-field
              outlined
              dense
              type="date"
              v-model="editedItem.todate"
            ></v-text-field>
          </v-col>
            </v-row>
           
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryDepreciationCycle()"
              >Update</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      inv_finance_approving_authority_list:[],inv_finance_approving_authority:"",
      inv_finance_approving_category_list:[],inv_finance_approving_category:"",
      inv_finance_approving_auth_level_list:[],
      level_no:"",islast:false,
      headers:[
      { text: "SR No", value: "srno" },
      { text: "Level No", value: "level_no" },
      { text: "Category", value: "invfinanceapprovingcategory" },
      { text: "Authority", value: "invfinanceapprovingauthority" },
      { text: "Is Last", value: "islast" },
      { text: "Is Active", value: "isactive" },
      // { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
    dialog_edit: false,
    editedItem: {
      id: "",ay:"",fromdate:"",todate:"",name:""
    },
  }),
   methods: {
      clearData(){
        this.inv_finance_approving_authority="",this.inv_finance_approving_category="",this.level_no="",this.islast=false
      },
      async saveUpdateInventoryDepreciationCycle(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryDepreciationCycle", this.editedItem);
          if (res.data.flag == "YES") {
            this.inv_depreciation_cycle_list=res.data.inv_depreciation_cycle_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.name = item.name_of_cycle;
      this.editedItem.ay = item.academicyear_id;
      this.editedItem.fromdate = item.from_date_edit;
      this.editedItem.todate = item.to_date_edit;
      this.dialog_edit = true;
    },
    async saveInventoryFinanceApprovingAuthorityLevel(){
        const data = {
        inv_finance_approving_authority:this.inv_finance_approving_authority,
        inv_finance_approving_category:this.inv_finance_approving_category,
        level_no:this.level_no,
        islast:this.islast
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryFinanceApprovingAuthorityLevel", data);
          if (res.data.flag == "YES") {
            this.inv_finance_approving_auth_level_list=res.data.inv_finance_approving_auth_level_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactiveInventoryFinanceApprovingAuthorityLevel(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveInventoryFinanceApprovingAuthorityLevel", data);
          if (res.data.flag == "YES") {
             this.inv_finance_approving_auth_level_list=res.data.inv_finance_approving_auth_level_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryFinanceApprovingAuthorityLevel(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryFinanceApprovingAuthorityLevel", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Deleted Successfully"); // show snackbar    
             this.inv_finance_approving_auth_level_list=res.data.inv_finance_approving_auth_level_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getInventoryFinanceApprovingAuthorityLevelList");
          if (res.data.flag == "YES") {
            this.inv_finance_approving_authority_list=res.data.inv_finance_approving_authority_list
            this.inv_finance_approving_category_list=res.data.inv_finance_approving_category_list
            this.inv_finance_approving_auth_level_list=res.data.inv_finance_approving_auth_level_list
            this.ay=res.data.cay
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>